import React, { Component } from 'react';
import axios from 'axios';
import config from 'react-global-configuration';
import { Card, Label, Input, Button } from 'reactstrap';
import CommonNavbar from './commonNavbar';
import jwt_decode from 'jwt-decode';

class AdminBankSchemesView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      bankDetails: {
        issuer_bank_display_name: '',
        emi_tenure_display_name: '',
        party_type: '',
        party_name: '',
        roi: '',
        effective_roi: '',
      },
    };
  }

  componentDidMount() {
    this.fetchBankDetails();
  }

  fetchBankDetails = () => {
    const token = localStorage.usertoken;
    const decoded = jwt_decode(token);
    const bankId = this.props.match.params.id;

    axios
      .post(
        `${config.get('API_URL')}/brandemi/get-bank-details`,
        { id: bankId },
        {
          headers: {
            Authorization: ` ${localStorage.usertoken}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
          this.setState({
            bankDetails: response.data,
            loading: false,
          });
      })
      .catch((error) => {
        console.error("Error fetching bank details:", error);
        this.setState({ loading: false });
      });
  };

  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    const { loading, bankDetails } = this.state;

    if (loading) {
      return <div>Loading...</div>;
    }

    return (
      <div className="content longcontent">
        <CommonNavbar />
        <div className="container-fluid">
          <div className="card-query-builder top-pad-5">
            <div className="col-md-12">
              <div className="card">
                <div className="header">
                  <h4 className="title pull-left">Bank Details</h4>
                  <Button
                    color="primary"
                    className="btn-capitalize pull-right"
                    onClick={this.goBack}
                  >
                    Go Back
                  </Button>
                </div>

                <div className="content">
                  <div className="container-fluid">
                    {/* First Row: Bank Name and EMI Tenure */}
                    <div className="row top-margin-10">
                      <div className="col-md-6">
                        <Label>Bank Name</Label>
                        <Input
                          type="text"
                          value={bankDetails.issuerBankName}
                          disabled
                        />
                      </div>
                      <div className="col-md-6">
                        <Label>EMI Tenure</Label>
                        <Input
                          type="text"
                          value={bankDetails.emiTenure}
                          disabled
                        />
                      </div>
                    </div>

                    {/* Second Row: Party Type and Party Name */}
                    <div className="row top-margin-10">
                      <div className="col-md-6">
                        <Label>Party Type</Label>
                        <Input
                          type="text"
                          value={bankDetails.partyType}
                          disabled
                        />
                      </div>
                      <div className="col-md-6">
                        <Label>Party Name</Label>
                        <Input
                          type="text"
                          value={bankDetails.partyName}
                          disabled
                        />
                      </div>
                    </div>

                    {/* Third Row: ROI and Effective ROI */}
                    <div className="row top-margin-10">
                      <div className="col-md-6">
                        <Label>ROI</Label>
                        <Input
                          type="text"
                          value={bankDetails.roi}
                          disabled
                        />
                      </div>
                      <div className="col-md-6">
                        <Label>Effective ROI</Label>
                        <Input
                          type="text"
                          value={bankDetails.effectiveRoi}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminBankSchemesView;